import React, { useState, useEffect } from 'react';
import Divider from '@mui/material/Divider';
import Waiting from './../items/Waiting';
import TR from './../../Trans';
import MuvikaService from './../../services/muvika';
import Stack from '@mui/material/Stack';
import Grid from '@mui/material/Grid';
import PerformanceSongbookListItem from '../items/PerformanceSongbookListItem';
import Box from '@mui/material/Box';
import ContentContainer from './../items/ContentContainer';
import List from '@mui/material/List';
import NewsListItem from './../items/NewsListItem';
import DeleteDialog from '../dialogs/DeleteDialog';
import EditSongbookPerformance from '../dialogs/EditSongbookPerformance';
import sessionStore from './../../stores/session';
import Button from '@mui/material/Button';
import settingsStore from '../../stores/settings';
import songbookSessionStore from './../../stores/songbookSession';
import newsStore from './../../stores/news';
import singersStore from './../../stores/singers';
import performanceStore from '../../stores/performance';
import navigationStore from '../../stores/navigation';
import messageStore from './../../stores/message';

function SongbookPerformances() {

  const sessionToken = songbookSessionStore((state) => state.sessionToken);
  const session = songbookSessionStore((state) => state.session);
  const playQueue = performanceStore((state) => state.playQueue);
  const isSongbookPublicBoothMode = songbookSessionStore((state) => state.isSongbookPublicBoothMode);
  const getPlayQueue = performanceStore((state) => state.getPlayQueue);
  const mySongRequestsDelivered = performanceStore((state) => state.mySongRequestsDelivered);
  const mySongRequestsPending = performanceStore((state) => state.mySongRequestsPending);
  const settings = settingsStore((state) => state.settings);
  const getSettings = settingsStore((state) => state.getSettings);
  const performanceToBeChanged = performanceStore((state) => state.performanceToBeChanged);
  const setPerformanceToBeChanged = performanceStore((state) => state.setPerformanceToBeChanged);
  const singers = singersStore((state) => state.singers);
  const getSingers = singersStore((state) => state.getSingers);
  const setError = messageStore((state) => state.setError);
  const clearPlayQueueSongbook = performanceStore((state) => state.clearPlayQueueSongbook);
  const setPaddingBottom = navigationStore((state) => state.setPaddingBottom);
  const setSongbookPerformanceToBeDeleted = performanceStore((state) => state.setSongbookPerformanceToBeDeleted);
  const removeSongbookPerformanceFromToBeDeleted = performanceStore((state) => state.removeSongbookPerformanceFromToBeDeleted);
  const songbookPerformancesToBeDeleted = performanceStore((state) => state.songbookPerformancesToBeDeleted);

  const [isEditPerformanceOpen, setIsEditPerformanceOpen] = useState(false);
  const [chosenPerformance, setChosenPerformance] = useState({});
  const [isChosenPerformanceEdited, setIsChosenPerformanceEdited] = useState(false);

  const [isClearDialogOpen, setIsClearDialogOpen] = useState(false);

  useEffect(() => {
    getPlayQueue(sessionToken);
    if (!settings) {
      getSettings(sessionToken);
    }
    if (!singers) {
      getSingers(sessionToken);
    }
    setPaddingBottom("muvika-songbook-performances", settings ? (isSongbookPublicBoothMode ? -40 : 0) : 0);
  }, []);

  useEffect(() => {
    setPaddingBottom("muvika-songbook-performances", settings ? (isSongbookPublicBoothMode ? -40 : 0) : 0);
  }, [settings]);

  const handleOpenClearDialog = () => {
    setIsClearDialogOpen(true);
  };

  const handleCloseClearDialog = () => {
    setIsClearDialogOpen(false);
  };

  const handleOpenEditPerformance = (performance, isEdited) => {
    setChosenPerformance(performance);
    setIsChosenPerformanceEdited(isEdited);
    setIsEditPerformanceOpen(true);
  };

  const handleCloseEditPerformance = () => {
    setIsEditPerformanceOpen(false);
  };

  const handleDeletePerformance = (performance) => {
    MuvikaService.createSongRequest(sessionToken, "del", performance.track.track_id, performance.profile.id, performance.pitch, [performance.unique_id])
      .then(function (res) {
        //console.log(res);
        if (res.data.error) {
          setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
        } else {
        }
      })
      .catch(function () { });
  };

  const performanceList = (showAll, showFirst = false) => {
    if (playQueue && settings && mySongRequestsDelivered && mySongRequestsPending) {
      return playQueue.items.map((performance, index) => {

        let isEdited = mySongRequestsDelivered.find(x => {
          if (x.req_type == "edit") {
            if (x.performance) {
              if (x.performance.unique_id == performance.unique_id) {
                return true;
              }
            }
          }
          return false;
        });
        let songReq = mySongRequestsDelivered.find(x => {
          if (x.req_type == "add") {
            if (x.performance) {
              if (x.performance.unique_id == performance.unique_id) {
                return x;
              }
            }
          }
          return undefined;
        });
        let delReq = mySongRequestsDelivered.find(x => {
          if (x.req_type == "del") {
            if (x.unique_ids) {
              if (x.unique_ids.includes(performance.unique_id)) {
                return x;
              }
            }
          }
          return undefined;
        });
        let delReqPend = mySongRequestsPending.find(x => {
          if (x.req_type == "del") {
            if (x.unique_ids) {
              if (x.unique_ids.includes(performance.unique_id)) {
                return x;
              }
            }
          }
          return undefined;
        });
        console.log("first", showFirst, performance.position, !(showFirst && performance.position == 0));
        if ((showAll || songReq) && (!showFirst && performance.position == 0 ? false : true)) {
          return <PerformanceSongbookListItem
            key={index}
            index={index}
            performance={performance}
            showIndex={showFirst}
            isDeleted={delReq || delReqPend ? true : false}
            isCurrent={songReq ? true : false}
            performanceToBeChanged={performanceToBeChanged}
            isSongReq={songReq}
            onEditPerformance={() => {
              if (songReq) {
                handleOpenEditPerformance(performance, isEdited);
              }
            }}
            onDelete={() => {
              if (songReq) {
                handleDeletePerformance(performance);
              }
            }}
          />;
        }
      }
      );
    }
  };

  const pendingPerformanceTitle = () => {
    if (mySongRequestsDelivered && mySongRequestsPending) {
      let songReq = mySongRequestsDelivered.filter(x => {
        if (x.performance) {
          return x;
        }
        return undefined;
      });
      if (mySongRequestsPending.length > 0) {
        return <i>
          {TR.cm_your_pending_song_requests}:
        </i>;
      }
    }
  };

  const pendingPerformanceList = () => {
    if (mySongRequestsPending) {
      //console.log(mySongRequestsPending);
      return mySongRequestsPending.map((performance, index) => {

        if (performance.performance) {
          return <PerformanceSongbookListItem
            key={index}
            index={index}
            performance={performance.performance}
          />;
        }
      }
      );
    }
  };

  const handlePerformanceToBeChanged = (performance) => {
    //console.log(performance);
    setPerformanceToBeChanged(performance);
  };

  const handleEdit = (pitch) => {
    MuvikaService.createSongRequest(sessionToken, "edit", chosenPerformance.track.track_id, chosenPerformance.profile.id, pitch, [chosenPerformance.unique_id])
      .then(function (res) {
        //console.log(res);
        if (res.data.error) {
          setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
        } else {
          setIsEditPerformanceOpen(false);
        }
      })
      .catch(function () { });
  };

  const editPerformanceDialog = () => {
    if (chosenPerformance.track) {
      return <EditSongbookPerformance
        open={isEditPerformanceOpen}
        isEdited={isChosenPerformanceEdited}
        onClose={handleCloseEditPerformance}
        onEdit={handleEdit}
        performance={chosenPerformance}
        onPerformanceToBeChanged={() => {
          handlePerformanceToBeChanged(chosenPerformance);
        }}
        singers={singers}
      />;
    }
  };

  const renderPerformances = () => {
    if (session && settings) {
      console.log("first", session.account.tags);
      if (session.account.tags.includes("consumer")) {
        return <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
          {performanceList(true, true)}
        </List>;
      } else {
        return <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
          {performanceList(isSongbookPublicBoothMode, isSongbookPublicBoothMode)}
        </List>;
      }
    }
  };

  const onClearing = () => {
    clearPlayQueueSongbook(sessionToken);
    handleCloseClearDialog();
  };

  const renderClearButton = () => {
    if (settings) {
      if (isSongbookPublicBoothMode) {
        return <Box mt={0} bottom="0" className="muvika-performances-bottom">
          <Stack className="muvika-playqueue-bottom-bar-stack" direction="row" spacing={2}>
            <Button variant="text" color="success" onClick={handleOpenClearDialog}>{TR.cm_clear}</Button>
          </Stack>
        </Box>;
      }
    }
  };

  const renderBottomText = () => {
    if (settings) {
      if (isSongbookPublicBoothMode) {
        return <i>{TR.cm_songbook_playlist_boothmode_info}</i>;
      }
    }
    if (session) {
      if (session.account.tags.includes("consumer")) {
        return <i>{TR.cm_songbook_playlist_home_info}</i>;
      } else {
        return <i>{TR.cm_songbook_playlist_pro_info}</i>;
      }
    }
  };

  return (
    <div>
      <DeleteDialog
        open={isClearDialogOpen}
        onClose={handleCloseClearDialog}
        onDeletion={onClearing}
        title={TR.cm_are_you_sure}
        cancel={TR.cm_cancel}
        delete={TR.cm_clear}
      />
      {editPerformanceDialog()}
      <h3>{TR.cm_playqueue}</h3>
      <ContentContainer id="muvika-songbook-performances" onScrollDown={() => {
      }} isFinished={true} isSongbook={true}>
        <div>
          {renderPerformances()}
          <List sx={{ width: '100%', marginTop: "2rem", marginBottom: "2rem", bgcolor: 'background.paper' }}>
            {pendingPerformanceTitle()}
            {pendingPerformanceList()}
          </List>
          {renderBottomText()}
        </div>
      </ContentContainer>
      {renderClearButton()}
    </div>
  );
}

export default SongbookPerformances;